<div class="header-title">
  <img id="engie-logo" [pTooltip]="VERSION" src="../../../../../assets/images/gnvert-style/engie-300.svg" alt="Engie Logo" />
  <a routerLink="/">
    <span>DOGESTAT Analyse</span>
  </a>
</div>
